import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    display: "flex",
    width: "205px",
    alignItems: "flex-start",
  },
  paper: {
    borderRadius: "4px",
    background: "#FFFFFF",
    boxShadow:
      "0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)",
  },
  list: {
    "& li": {
      color: "#000000DE",
      "& svg": {
        marginRight: "10px",
        color: "#000000DE",
      },
    },
  },
  buttonText: {
    padding: "0px !important",
    width: "100%",
  },
  dialogText: {
    color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
    letterSpacing: "0.15px",
    padding: "0px",
  },
  buttonTypography: {
    fontFamily: "Inter",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "22px", /* 169.231% */
    letterSpacing: "0.46px",
    textTransform: "uppercase",
  },
}));
